import Gator from 'gator';
import TouchAndMobile from './TouchAndMobile';
import checkMatch from './Functions/checkMatch';
import getParents from './Functions/getParents';
import nodeArray from './Functions/nodeArray';
import getGrandChildren from './Functions/getGrandChildren';

class deepMenu {
    constructor({ namespace, header, hamburger }) {
        this.fetchUrl = '/mobile.menu';
        this.replaceableElement = document.getElementById(namespace);
        this.header = header;
        this.hamburger = hamburger;
        this.namespace = namespace;
        this.cssClass = {
            activeLink: `${namespace}__link--active`,
            activeButton: `${namespace}__button--active`,
            activeList: `${namespace}__list--active`,
            hideButton: `${namespace}__button--hide`
        };
        this.selector = {
            navigation: `.${namespace}`,
            wrapper: `.${namespace}__wrapper`,
            list: `.${namespace}__list`,
            rootList: `.${namespace}__list--root`,
            activeList: `.${this.cssClass.activeList}`,
            prevButton: `.${namespace}__button--prev`,
            nextButton: `.${namespace}__button--next`,
            overlay: `.${namespace}__overlay`
        };

        this.checkSizeAndFetch();
    }

    checkSizeAndFetch() {
        if (!this.replaceableElement) {
            return;
        }

        let resizeId;
        let needFetch = true;
        // We have to get rid of this inside gator
        let that = this;
        function fetchMenu() {
            if (needFetch) {
                needFetch = false;
                that.getAndReplaceMarkup();
                Gator(window).off('resize', fetchMenuTimeout);
            }
        }

        function fetchMenuTimeout() {
            clearTimeout(resizeId);
            resizeId = setTimeout(fetchMenu, 500);
        }

        if (this.replaceableElement) {
            fetchMenu();
            if (needFetch) {
                Gator(window).on('resize', fetchMenuTimeout);
            }
        }
    }

    static isVisible(element) {
        return element.offsetParent !== null;
    }

    getAndReplaceMarkup() {
        // fetch(this.fetchUrl)
        //     .then(response => response.text())
        //     .then(htmlString => {
        // // Create element from html
        // let div = document.createElement('div');
        // div.innerHTML = htmlString.trim();
        // // Change this to div.childNodes to support multiple top-level nodes
        // let menu = div.firstChild;

        // // Check if the menu is fetched correctly
        // if (menu.id != 'deep-nav') {
        //     console.error("The menu couldn't fetched correctly.");
        //     return;
        // }

        const menu = document.querySelector('#deep-nav');

        // set active states to links, buttons and lists
        let path = window.location.pathname;
        // Try to get the current link
        let active = menu.querySelector(`a[href$="${path}"]`);
        if (!active) {
            // If no link found, move the path up as long we have a path
            while (!active && path) {
                path = path
                    .split('/')
                    .slice(0, -1)
                    .join('/');
                active = menu.querySelector(`a[href$="${path}"]`);
            }
        }
        if (active) {
            // We have an active link
            active.classList.add(this.cssClass.activeLink);
            let parents = getParents(active, `${this.selector.list}:not(${this.selector.rootList})`, menu);
            parents.forEach(list => {
                let button = list.previousElementSibling;
                if (checkMatch(button, this.selector.nextButton)) {
                    button.classList.add(this.cssClass.activeButton);
                }

                list.classList.add(this.cssClass.activeList);
            });
            menu.setAttribute('data-level', parents.length);
        }

        // Replace element with menu
        if (this.replaceableElement.parentNode) {
            this.replaceableElement.parentNode.replaceChild(menu, this.replaceableElement);
        }

        // Add a CSS class to the html element
        document.documentElement.classList.add('-mobilemenu-loaded');

        this.menu = new TouchAndMobile({
            selector: {
                header: `.${this.header}`,
                navigation: this.selector.navigation,
                hamburger: `.${this.hamburger}`
            },
            header: `.${this.header}`,
            namespace: this.namespace,
            hamburger: `.${this.hamburger}`,
            setTop: false
        });
        if (this.setElements()) {
            this.goToMenuLevel({ list: this.activeList, active: true });
            this.setEvents();
            this.registerDialogButtons();
        }
        // })
        // .catch(error => console.error(error));
    }

    registerDialogButtons() {
        let menu = this.menu;
        Gator(this.navigation).on('click', '[data-a11y-dialog-show]', function() {
            let name = this.getAttribute('data-a11y-dialog-show');
            if (Carbon('dialogues') && Carbon('dialogues')[name]) {
                menu.close();
                Carbon('dialogues')[name].show();
            }
        });
    }

    setElements() {
        this.navigation = document.querySelector(this.selector.navigation);

        if (!this.navigation) {
            return false;
        }

        this.wrapper = this.navigation.querySelector(this.selector.wrapper);
        this.rootList = this.navigation.querySelector(this.selector.rootList);
        this.prevButton = this.navigation.querySelector(this.selector.prevButton);
        this.menuLevel = parseInt(this.navigation.dataset.level) || 0;

        let activeLists = this.navigation.querySelectorAll(this.selector.activeList);
        // Get last element
        this.activeList = activeLists.length ? activeLists[activeLists.length - 1] : this.rootList;
        return true;
    }

    goToMenuLevel({ list, active }) {
        this.navigation = document.querySelector(this.selector.navigation);
        this.navigation.setAttribute('data-level', this.menuLevel);

        let oldActiveList = document.querySelector('[data-current="true"]');
        if (oldActiveList) {
            oldActiveList.setAttribute('data-current', 'false');
        }
        let newActiveList = document.querySelector('.deep-nav__list[data-level="' + this.menuLevel + '"]');
        if (newActiveList) {
            newActiveList.setAttribute('data-current', 'true');
        }

        let percentToTranslate = 0;
        if (this.menuLevel > 0) {
            percentToTranslate = this.menuLevel * 100 - 15;
        }
        this.rootList.style.transform = `translateX(-${percentToTranslate}%)`;

        this.prevButton.classList[this.menuLevel ? 'remove' : 'add'](this.cssClass.hideButton);
        this.prevButton.setAttribute('tabindex', this.menuLevel ? '0' : '-1');
        if (list != this.rootList) {
            list.classList[active ? 'add' : 'remove'](this.cssClass.activeList);
        }

        this.activeList = active ? list : list.parentNode.closest(this.selector.list);
    }

    setTabindex() {
        // Set the tabindex after TouchAndMobile
        setTimeout(() => {
            nodeArray('[tabindex="0"]', this.rootList).forEach(element => {
                element.setAttribute('tabindex', '-999');
            });
            getGrandChildren(this.activeList, '[tabindex="-999"]').forEach(element => {
                element.setAttribute('tabindex', '0');
            });
            this.prevButton.focus();
            this.prevButton.blur();
        }, 500);
    }

    setEvents() {
        Gator(document).on('mobileMenu.open', () => {
            this.setTabindex();
            this.setWrapperHeight();
            this.navigation.removeAttribute('aria-hidden');
        });
        Gator(document).on('mobileMenu.close', () => {
            this.wrapper.removeAttribute('style');
            this.navigation.setAttribute('aria-hidden', true);
        });
        Gator(document).on('click', this.selector.overlay, () => {
            this.menu.close();
        });
        Gator(document).on('click', '.deep-nav__close', () => {
            const that = this;
            document.querySelector('html').classList.add('-menuclosing');
            document.querySelector('body').classList.add('-menuclosing');
            setTimeout(function() {
                that.menu.close();
                document.querySelector('html').classList.remove('-menuclosing');
                document.querySelector('body').classList.remove('-menuclosing');
            }, 500);
        });
        Gator(document).on('click', this.selector.nextButton, event => {
            this.menuLevel++;
            this.goToMenuLevel({ list: event.target.nextElementSibling, active: true });
            this.setTabindex();
            this.setWrapperHeight();
        });
        Gator(document).on('click', this.selector.prevButton, () => {
            this.menuLevel = this.menuLevel < 1 ? 0 : this.menuLevel - 1;
            this.goToMenuLevel({ list: this.activeList, active: false });
            this.setTabindex();
            this.setWrapperHeight();
        });
    }

    setWrapperHeight() {
        this.wrapper.style.height = `${this.activeList.offsetHeight + 1}px`;
    }
}

export default deepMenu;
